<template>
  <div class="layout-wrap">
    <PlayHeader />
    <nuxt />
    <client-only>
      <LoginPop v-if="$store.state.app.showLoginPop" />
    </client-only>
    <SaveDesktop v-if="hasIco" />
  </div>
</template>

<script>
import PlayHeader from '../components/layout/GamePlayHeader'
import LoginPop from '../components/logic-common/LoginPop'
import SaveDesktop from '../components/play/SaveDesktop'
export default {
  middleware: 'checkLogin',
  components: {
    PlayHeader,
    LoginPop,
    SaveDesktop
  },
  data() {
    return {
      showCert: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    game() {
      return this.$store.state.game.info
    },
    hasIco() {
      return this.game.jump_url
    }
  },
  provide() {
    return {
      showCertPop: this.showCertPop
    }
  },
  created() {
    if (process.client) {
      const { game_id } = this.$route.params
      this.$store.dispatch('game/getGameDetail', game_id)
    }
  },
  mounted() {
    setTimeout(() => {
      this.$store.dispatch('getUserInfo')
    }, 2000)
  },
  methods: {
    certSuccess() {
      this.$store.dispatch('getUserInfo')
    },
    showCertPop(flag = true) {
      if (this.$store.getters.authStatus !== 0 && this.$store.getters.isLogin) {
        this.showCert = !!flag
      }
    }
  }
  // head() {
  //   const { description = '', title = '' } = this.game
  //   // const { server_name = '' } = this.$route.query
  //   return {
  //     title: description || `${title} | 迅雷游戏平台`
  //   }
  // }
}
</script>
